import routes from './routes';
import { SetRoutes } from 'components';

const FootfallPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default FootfallPages;
